import { gql } from '@apollo/client'

export default gql`
  mutation DELETE_ORGANIZATION_IMAGE(
    $id: Int!
  ) {
    data: update_organization_images_by_pk (
      pk_columns: { id: $id },
      _set: {
        is_deleted: true,
      }
    ) {
      id
    }
  }
`
